import React from "react"
import { graphql } from "gatsby"

import Layout from "./../../components/Layout"
import SEO from "./../../components/Seo"
import HeaderTitle from "./../../components/HeaderTitle"
import ContentBlock from "./../../components/ContentBlock"
import BackgroundDots from "./../../components/BackgroundDots"
import Team from "./../../components/Team"

const Dots = [
  {
    mobile: {
      x: 0,
      y: 80,
      position: "left",
      ellipse: 20,
      circle: 200,
    },
    desktop: {
      x: -25,
      y: 550,
      position: "left",
      ellipse: 150,
      circle: 400,
    },
  },
  {
    mobile: {
      x: 100,
      y: 1250,
      position: "right",
      ellipse: 45,
      circle: 150,
    },
    desktop: {
      x: 100,
      y: 1400,
      position: "right",
      ellipse: 90,
      circle: 310,
    },
  },
]

const Leadership = ({ data: { prismicCompany } }) => (
  <Layout theme="dark">
    <SEO title={prismicCompany.data.header_title.text} />

    <HeaderTitle label={prismicCompany.data.header_title.text} />
    <ContentBlock data={prismicCompany.data.content.html} />
    <ContentBlock data={prismicCompany.data.content_01.html} />
    <ContentBlock data={prismicCompany.data.content_02.html} />
    <ul>
      {prismicCompany.data.teams.map(
        ({
          team: {
            document: [{ id, data }],
          },
        }) => (
          <li key={id}>
            <Team {...data} />
          </li>
        )
      )}
    </ul>

    <BackgroundDots data={Dots} />
  </Layout>
)

export default Leadership

export const pageQuery = graphql`
  query {
    prismicCompany {
      data {
        header_title {
          text
        }
        content {
          html
        }
        content_01 {
          html
        }
        content_02 {
          html
        }
        teams {
          team {
            document {
              id
              data {
                name
                members {
                  member {
                    document {
                      id
                      data {
                        name
                        bio
                        picture {
                          alt
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
